import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Enrollment } from './models/Enrollment';
import TopNavActions from './TopNavActions';

interface NotInterestedThankYouViewProps {
  enrollment: Enrollment;
  onPageChange: (page: string) => void;
}

const NotInterestedThankYouView: React.FC<NotInterestedThankYouViewProps> = ({ onPageChange }) => {
  const { t } = useTranslation('enrollment');

  const handleFinish = () => {
    onPageChange('finish');
  };

  const handleBack = () => {
    onPageChange('back');
  };

  return (
    <React.Fragment>
      <TopNavActions
        onBack={handleBack}
        hideExit={true}
      />

      <Typography variant="h4" component='h1' id="page-heading" tabIndex={-1} sx={{ mb: 2 }}>{t("Thank you for your time")}</Typography>
      <Typography variant="body1" component='div'>
        {t("You can always change your mind, and register in the future.")}
      </Typography>
      <Button variant="contained" onClick={handleFinish} style={{ marginTop: 32, marginBottom: 32 }}>
        {t("Finish")}
      </Button>
    </React.Fragment>
  );
}

export default NotInterestedThankYouView;
